import { StoreFromJson, Collection } from 'smartdishpro-scripts/ts_common';
import { db } from '../firebase';

const _storesRef = (merchantId: string) =>
  db
    .collection(Collection.Merchants)
    .doc(merchantId)
    .collection(Collection.Stores);

export const getStore = async (merchantId: string, storeId: string) => {
  const snapshot = await _storesRef(merchantId).doc(storeId).get();
  const data = snapshot.data({ serverTimestamps: 'estimate' });
  if (!snapshot.exists || !data) return undefined;
  const store = StoreFromJson(data, snapshot.id);
  // 業態変更対応: Store型未定義のためany経由で取得
  (store as any).needsDeauthorize = data.needsDeauthorize ?? false;
  return store;
};
